import React, { ReactNode } from 'react';
import Card from 'components/Card';
import cx from 'classnames';
import styles from './Container.module.css';

export interface ContainerProps {
  children: ReactNode;
  title: ReactNode;
  footer?: ReactNode;
  className?: string;
}

export function Container({ children, title, className }: ContainerProps) {
  return (
    <Card className={cx(styles['Container'], className)} header={<h2>{title}</h2>} transparentTitle>
      {children}
    </Card>
  );
}
